// Resolves which supplementary columns a report renders.
//
// On the Report tab the answer is live client state: the column preset and any
// "Customise columns" overrides held by the report context. A generated report
// re-opened from the Generated Reports list renders OUTSIDE that provider, so
// there is no live state to read — it carries its own column set instead, stored
// with the report when it was generated (ActualCostsReportResource exposes it as
// `column_preset` / `visible_columns`).
//
// An archived report must render with the columns it was generated with, not
// with whatever the configuration screen happens to show now, so the stored
// value wins wherever it exists.

import { columnsForPreset, DEFAULT_COLUMN_PRESET } from '../types/ReportColumns';

/**
 * @param {Object} context      The Actuals vs Budget report context (may be empty).
 * @param {Object} storedReport A generated report's own parameters, when rendered
 *                              outside the configuration form. Takes precedence.
 * @returns {Object<string, boolean>} Column key → visible.
 */
export const resolveVisibleColumns = (context = {}, storedReport = null) => {
    if (storedReport) {
        // The preset supplies the base set; the overrides — the map the
        // "Customise columns" grid produced — are layered on top, exactly as the
        // live provider layers them. Reports generated before either was stored
        // carry the standard preset and no overrides, which is how they rendered
        // when they were generated.
        return {
            ...columnsForPreset(storedReport.column_preset || DEFAULT_COLUMN_PRESET),
            ...(storedReport.visible_columns || {}),
        };
    }

    // Outside the provider with nothing stored, no supplementary column can be
    // vouched for — render the three time bases alone rather than inventing a
    // column set. (Unchanged from how these tables behaved before.)
    return context.visibleColumns || {};
};
